var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCommercialManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-121 -203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.79167 3.35417 3.35417 3.35417 3.35417 19.6458 19.6458 19.6458 19.6458 18.2083 4.79167 18.2083Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.04348 121 203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 7.42708 17.226 8.84062 15.3333 10.7333 13.8958 9.29583 11.5 11.6917 10.0625 10.2542 5.72604 14.5906 6.73229 15.5969 10.0625 12.2667 11.5 13.7042 13.8958 11.3083 15.3333 12.7458 18.2323 9.84687 19.6458 11.2604 19.6458 7.42708Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.04348 121 203)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommercialManagement);
export default __webpack_public_path__ + "static/media/icon-commercial-management.3f44a3aa84caf6c120003387dcdfbecf.svg";
export { ForwardRef as ReactComponent };